/**
 * @desc 查询中台系统订单分页
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.SystemOrderRequestRpcDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/omsflow/getOrderPage`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
